import { useEffect, useState } from 'react';

/**
 * Thin wrapper around `navigator.onLine` + the `online` / `offline` window
 * events. `navigator.onLine` is the best signal we have client-side — it
 * reflects the OS-reported network state, not end-to-end connectivity — so
 * this is a "probably online" hint, not a guarantee. Good enough for the
 * offline banner; actual requests still fall back through the SW cache if
 * the network turns out to be unreachable.
 */
export const useOnlineStatus = () => {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);

  return online;
};

export default useOnlineStatus;
